<template>
  <div class="amuseAc">
    <van-image lazy-load loading-icon="" src="https://oss.dayulong.cn/IndexCarousel/youngmusic1.jpg" />
    <van-image lazy-load loading-icon="" src="https://oss.dayulong.cn/IndexCarousel/youngmusic2.jpg" />
    <van-image lazy-load loading-icon="" src="https://oss.dayulong.cn/IndexCarousel/youngmusic3.jpg" />
    <van-image lazy-load loading-icon="" src="https://oss.dayulong.cn/IndexCarousel/youngmusic4.jpg" />
    <van-image lazy-load loading-icon="" src="https://oss.dayulong.cn/IndexCarousel/youngmusic5.jpg" />
    <van-image lazy-load loading-icon="" src="https://oss.dayulong.cn/IndexCarousel/youngmusic6.jpg" />
    <van-image lazy-load loading-icon="" src="https://oss.dayulong.cn/IndexCarousel/youngmusic7.jpg" />
  </div>
</template>

<script>
import { Image } from 'vant';

export default {
  name: 'amuseAc',
  components: {
    VanImage: Image,
  }
}
</script>

<style lang="scss">
.amuseAc {
  .van-image {
    display: block;
    width: 100%;
  }
  img {
    display: block;
    width: 100%;
  }
}
</style>